import { FC } from 'react'
import Link from 'next/link'

import { Icon, IconName } from '~/src/components/generic/PhosphorIcons/index'

import { tw } from '~/lib/utils'

type Props = {
  title: string
  href: string
  active: boolean
  icon: IconName
  onFocus?: () => void
  onMouseEnter?: () => void
}

const SidebarLink: FC<Props> = ({
  title,
  href,
  active,
  icon,
  onFocus,
  onMouseEnter,
}) => {
  return (
    <Link
      aria-current={active ? 'page' : undefined}
      className={tw(
        'flex w-full cursor-pointer items-center justify-center py-2 transition hover:bg-ryder-red-primary/70 focus:bg-ryder-red-primary/70 focus:outline-none',
        active ? 'border-l-4 border-ryder-red-secondary bg-gray-700' : ''
      )}
      href={href}
      onFocus={onFocus}
      onMouseEnter={onMouseEnter}
    >
      <div className="flex flex-col items-center space-y-2">
        <Icon color="#fff" name={icon} size="24" />
        <p className="text-label-xs font-normal text-inverted">{title}</p>
      </div>
    </Link>
  )
}

export default SidebarLink
